import React from 'react';
import { Route } from 'react-router-dom';
import Accumulations from './pages/Accumulation';
import BuyMonos from './pages/BuyMonos';
import Game from './pages/Game';
import Tokmomics from './pages/Toknomics';
import LandingPage from './pages/LandingPage';
import MarketPlace from './pages/MarketPlace';
import Inventory from './pages/Inventory';
import BinanceSwap from './pages/BinanceSwap';
import Stacking from './pages/Staking';

function Routes() {
  return [
      <>
        <Route path="/" component={ LandingPage } exact />
        <Route path="/home" component={ LandingPage } exact />
        <Route path="/buy-monos" component={ BuyMonos } exact />
        <Route path="/market-place/:name" component={ MarketPlace } />
        <Route path="/game" component={ Game } exact />
        <Route path="/toknomics" component={ Tokmomics } exact />
        <Route path="/accumulation" component={ Accumulations } exact />
        <Route path="/binance-swap" component={ BinanceSwap } exact />
        <Route path="/inventory" component={ Inventory } exact />
        <Route path="/staking" component={ Stacking } exact />
      </>
  ];
}

export default Routes;
